import React, { useMemo } from "react";
import { Box } from "@mui/material";
import PopperMenu from "@metacrm/metacrm-material-ui/dist/PopperMenuNew";

export default function XSortDropDown({ sortKey, setSortKey }) {
  const sortList = [
    { label: "Highest impressions", value: "impressions" },
    { label: "Highest engagement", value: "engagement" },
    { label: "Most recent", value: "postDate" },
  ];

  const handleReset = () => {
    setSortKey("");
  };

  return (
    <PopperMenu
      type="sort"
      anchorAlign={"end"}
      selectedItems={sortKey}
      setSelectedItems={setSortKey}
      showMenuListTitle={true}
      onMenuTitleButtonClick={handleReset}
      menuItemGroup={[
        {
          menuItemId: "sort",
          menuItemTitle: "Sort",
          menuItems: sortList.map((item) => ({
            value: item.value,
            label: item.label,
          })),
          canMultiSelect: false,
          onClick: (selected) => console.log("Sort Selected:", selected),
        },
      ]}
    />
  );
}
